import {
	json,
	type LoaderFunctionArgs,
	type MetaFunction,
} from '@remix-run/node'
import { Link } from '@remix-run/react'
import { useRef } from 'react'
import CarouselComponent from '#app/components/testimonials-carousel.js'
import { Icon } from '#app/components/ui/icon.js'

export const meta: MetaFunction = () => [{ title: 'Moni' }]

export async function loader({ request }: LoaderFunctionArgs) {
	return json({})
}

const stepsToUseMony = [
	{
		step: 1,
		title: 'Conéctate con Moni en WhatsApp:',
		description: 'Simplemente añade nuestro número y empieza a chatear.',
	},
	{
		step: 2,
		title: 'Registra tus finanzas al instante:',
		description:
			'Envía mensajes sobre tus gastos e ingresos y Moni los registrará automáticamente.',
	},
	{
		step: 3,
		title: 'Visualiza tu progreso:',
		description:
			'Accede a tu panel en la web para ver reportes detallados y análisis de tus finanzas.',
	},
]

const faqs = [
	{
		title: '¿Cómo se conecta Moni con mi WhatsApp?',
		description:
			'Al momento de registrarte se envía un mensaje de confirmación vía WhatsApp. ¡Así de fácil!',
	},
	{
		title: '¿Es seguro usar Moni?',
		description:
			'Sí, utilizamos cifrado de extremo a extremo para garantizar que tus datos estén siempre seguros.',
	},
	{
		title: '¿Puedo ver mis registros desde la web?',
		description:
			'Sí, puedes acceder a tu panel de control en cualquier momento para ver todos tus registros y reportes.',
	},
]

export default function Index() {
	const emblaRef = useRef<any>(null)

	const handlePrev = () => {
		emblaRef.current?.scrollPrev()
	}

	const handleNext = () => {
		emblaRef.current?.scrollNext()
	}

	return (
		<main className="place-items-top grid h-full">
			{/* Menu */}
			<section className="w-full bg-background-300">
				<div className="container md:flex">
					<div className="flex w-full flex-col justify-center md:w-1/2">
						<h1 className="mb-5 text-h2 text-primary-700 md:text-mega">
							<span className="text-tertiary">Moni:</span> Lleva el control de
							tus finanzas en pareja fácilmente
						</h1>

						<p className="mb-8 text-body-lg">
							Registra y gestiona tus gastos compartidos directamente desde
							WhatsApp.
						</p>

						<div>
							<Link
								to="/signup?redirectTo=/dashboard"
								className="inline-block rounded-full border border-primary-700 px-5 py-3 text-body-md font-bold"
							>
								Empieza ahora
							</Link>
						</div>
					</div>
					<div className="w-full md:w-1/2">
						<img
							src="/img/marketing/img-principal.png"
							alt="Atf"
							className="w-full"
						/>
					</div>
				</div>
				<div className="container">
					<div className="flex h-24 w-52 items-center justify-center bg-[url(/img/marketing/arrow-atf_bg.svg)] bg-cover">
						<img
							src="/img/marketing/arrow-atf.svg"
							alt="icon-arrow"
							className="h-10"
						/>
					</div>
				</div>
			</section>

			{/**
			 * Como funciona
			 */}
			<section id="como-funciona" className="mb-10 w-full bg-white py-10">
				<div className="container">
					<div className="mb-16">
						<h2 className="text-center text-h2">
							<span className="text-tertiary">¿Cómo funciona</span> Moni?
						</h2>
					</div>
					<div className="md:flex">
						<div className="flex w-full flex-col justify-center md:w-1/2">
							{stepsToUseMony.map(item => (
								<div
									key={item.step}
									className="group mb-5 ml-auto flex  w-full items-center gap-4 rounded-2xl border border-card p-4 hover:bg-background-300 md:w-[450px]"
								>
									<div className="w-6 shrink-0 text-center text-body-2xl font-bold">
										{item.step}
									</div>
									<div>
										<div className="text-body-md font-bold">{item.title}</div>
										<div>{item.description}</div>
									</div>
									<div className="w-6 shrink-0">
										<img
											src="/img/marketing/arrow-right-s-line.svg"
											alt=">"
											className="w-5 rounded-full border border-primary-700 group-hover:bg-tertiary"
										/>
									</div>
								</div>
							))}
						</div>
						<div className="w-full bg-[url(/img/marketing/guia_bg.svg)] bg-contain bg-center bg-no-repeat md:w-1/2 md:bg-auto">
							<img
								src="/img/marketing/guia_screen_0.png"
								alt="paso 0"
								className="mx-auto block"
							/>
						</div>
					</div>
				</div>
			</section>

			{/* Beneficios */}
			<section id="beneficios" className="mb-10 bg-white py-10">
				<div className="container">
					<div className="mb-16">
						<h2 className="text-center text-h2">
							Beneficios de usar <span className="text-tertiary">Moni</span>
						</h2>
					</div>
					<div className="flex gap-4">
						<div className="flex flex-col justify-center">
							<div className="flex h-1/2 flex-col-reverse justify-end gap-4 p-4 md:flex-row">
								<div className="w-full text-center md:text-right">
									<h3 className="text-body-md font-bold">Fácil y rápido</h3>
									<p>No necesitas salir de WhatsApp.</p>
								</div>
								<div className="shrink-0 pt-1">
									<img
										src="/img/marketing/ben_facil_rapido.png"
										alt="wsp"
										className="m-auto"
									/>
								</div>
							</div>
							<div className="flex h-1/2 flex-col-reverse justify-end gap-4 p-4 md:flex-row">
								<div className="w-full text-center md:text-right">
									<h3 className="text-body-md font-bold">Automatización</h3>
									<p>
										Moni actualiza tus registros y los de tu pareja
										automáticamente.
									</p>
								</div>
								<div className="shrink-0 pt-1">
									<img
										src="/img/marketing/ben_automatizacion.png"
										alt="stats"
										className="m-auto"
									/>
								</div>
							</div>
						</div>
						<div className="hidden md:block">
							<img
								src="/img/marketing/guia_screen_0.png"
								alt="paso 0"
								className="mx-auto block"
							/>
						</div>
						<div>
							<div className="flex h-1/2 flex-col justify-start gap-4 p-4 md:flex-row">
								<div className="shrink-0 pt-1">
									<img
										src="/img/marketing/ben_seguridad.png"
										alt="escudo"
										className="m-auto"
									/>
								</div>
								<div className="w-full text-center md:text-left">
									<h3 className="text-body-md font-bold">Seguridad</h3>
									<p>
										Tus datos están protegidos con cifrado de extremo a extremo.
									</p>
								</div>
							</div>
							<div className="flex h-1/2 flex-col justify-start gap-4 p-4 md:flex-row">
								<div className="shrink-0 pt-1">
									<img
										src="/img/marketing/ben_accesibilidad.png"
										alt="folder"
										className="m-auto"
									/>
								</div>
								<div className="w-full text-center md:text-left">
									<h3 className="text-body-md font-bold">Accesibilidad</h3>
									<p>Consulta tu historial y reportes en cualquier momento.</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>

			{/**
			 * Testimonios
			 */}
			<section
				id="testimonios"
				className="mb-10 w-full bg-gradient-to-b from-tertiary from-50% to-white to-50% py-10"
			>
				<div className="container">
					<div className="mb-10 flex">
						<div className="w-2/3 text-white md:w-1/2">
							<h2 className="text-h2">Lo que dicen nuestros usuarios</h2>
							<p className="text-body-md">
								Descubre cómo Moni ha transformado la gestión financiera de
								nuestros usuarios.
							</p>
						</div>
						<div className="flex w-1/3 flex-row items-end justify-end gap-2 md:w-1/2">
							<div
								onClick={handlePrev}
								className="flex cursor-pointer select-none justify-center rounded-full border border-white p-2"
							>
								<Icon
									name="arrow-left"
									size="xl"
									children
									className=" text-white"
								></Icon>
							</div>
							<div
								onClick={handleNext}
								className="flex cursor-pointer select-none justify-center rounded-full border border-white p-2"
							>
								<Icon
									name="arrow-right"
									size="xl"
									children
									className=" text-white"
								></Icon>
							</div>
						</div>
					</div>
					<div className="">
						<CarouselComponent ref={emblaRef} />
					</div>
				</div>
			</section>

			{/**
			 * Planes
			 */}
			<section
				id="planes-y-precios"
				className="mb-10 w-full bg-background-300 py-10"
			>
				<div className="container mb-10">
					<div className="mb-16  ">
						<h2 className="text-center text-h2">
							Elige tu <span className="text-tertiary">Plan</span>
						</h2>
					</div>
					<div className="mx-auto grid max-w-4xl  grid-cols-2 rounded-xl bg-white p-4 shadow-lg md:grid-cols-3 ">
						{/* Col 1 */}
						<div className="col-span-2 border-tertiary md:col-span-1 md:border-b-2"></div>
						<div className="flex items-center justify-center border-b-2 border-tertiary py-3 text-body-md font-semibold text-secondary md:border-l-2 md:text-body-lg">
							Plan Gratuito
						</div>
						<div className="flex items-center justify-center border-b-2 border-l-2 border-tertiary text-body-md font-bold text-primary md:text-body-lg">
							Plan Premium
						</div>

						<div className="col-span-2 flex items-center justify-start px-1 py-2 font-bold md:col-span-1 md:px-4">
							Registros ilimitados
						</div>
						<div className="flex items-center justify-center border-tertiary py-3 text-center md:border-l-2 md:py-5 ">
							<Icon name="check" size="xl" className="text-primary"></Icon>
						</div>
						<div className="flex items-center justify-center border-l-2 border-tertiary py-3 text-center md:py-5">
							<Icon name="check" size="xl" className="text-primary"></Icon>
						</div>

						<div className="col-span-2 flex items-center justify-start border-t-2 border-tertiary px-1 py-2 font-bold md:col-span-1 md:px-4">
							Acceso básico a reportes
						</div>
						<div className="flex items-center justify-center border-tertiary py-3 text-center md:border-l-2 md:py-5">
							<Icon name="check" size="xl" className="text-primary"></Icon>
						</div>
						<div className="flex items-center justify-center border-l-2 border-tertiary py-3 text-center md:py-5">
							<Icon name="check" size="xl" className="text-primary"></Icon>
						</div>

						<div className="col-span-2 flex items-center justify-start border-t-2 border-tertiary px-1 py-2 font-bold md:col-span-1 md:px-4">
							Reportes avanzados y análisis
						</div>
						<div className="flex items-center justify-center border-tertiary py-3 text-center md:border-l-2 md:py-5">
							<Icon name="cross-1" size="xl" className=" text-red-600"></Icon>
						</div>
						<div className="flex items-center justify-center border-l-2 border-tertiary py-3 text-center md:py-5">
							<Icon name="check" size="xl" className="text-primary"></Icon>
						</div>

						<div className="col-span-2 flex items-center justify-start border-t-2 border-tertiary px-1 py-2 font-bold md:col-span-1 md:px-4">
							Soporte vía WhatsApp
						</div>
						<div className="flex items-center justify-center border-tertiary py-3 text-center md:border-l-2 md:py-5">
							<Icon name="check" size="xl" className="text-primary"></Icon>
						</div>
						<div className="flex items-center justify-center border-l-2 border-tertiary py-3 text-center md:py-5">
							<Icon name="check" size="xl" className="text-primary"></Icon>
						</div>

						<div className="col-span-2 flex items-center justify-start border-t-2 border-tertiary px-1 py-2 font-bold md:col-span-1 md:px-4">
							Soporte prioritario
						</div>
						<div className="flex items-center justify-center border-tertiary py-3 text-center md:border-l-2 md:py-5">
							<Icon name="cross-1" size="xl" className=" text-red-600"></Icon>
						</div>
						<div className="flex items-center justify-center border-l-2 border-tertiary py-3 text-center md:py-5">
							<Icon name="check" size="xl" className="text-primary"></Icon>
						</div>

						<div className="col-span-2 flex items-center justify-start border-t-2 border-tertiary px-1 py-2 font-bold md:col-span-1 md:px-4">
							Integración con otras herramientas
						</div>
						<div className="flex items-center justify-center border-tertiary py-3 text-center md:border-l-2 md:py-5">
							<Icon name="cross-1" size="xl" className=" text-red-600"></Icon>
						</div>
						<div className="flex items-center justify-center border-l-2 border-tertiary py-3 text-center md:py-5">
							<Icon name="check" size="xl" className="text-primary"></Icon>
						</div>

						<div className=" col-span-2 md:col-span-1"></div>

						{/* Col 2 */}

						<div className="flex items-center justify-center border-tertiary py-4 text-center md:border-l-2">
							<Link
								to="/signup?redirectTo=/dashboard"
								className="inline-block rounded-full border border-primary-700 px-3 py-3 font-bold"
							>
								Empieza Gratis
							</Link>
						</div>
						{/* Col 3 */}

						<div className="flex items-center justify-center border-l-2 border-tertiary p-2  text-center">
							<Link
								to="/signup?redirectTo=/dashboard"
								className="inline-block rounded-full border border-background-800 bg-background-800 px-3 py-3 font-bold text-white"
							>
								Empieza con Premium
							</Link>
						</div>
					</div>
				</div>
			</section>

			{/**
			 * Preguntas frecuentes
			 */}
			<section id="faq" className="mb-10 w-full py-10">
				<div className="container flex flex-col md:flex-row">
					<div className="mb-6 text-center md:mb-0 md:w-1/2">
						<img src="/img/marketing/faqs_personas.png" alt="Preguntas" />
					</div>
					<div className="md:w-1/2">
						<div className="mb-10">
							<h2 className="mb-5 text-left text-h2">
								Preguntas <span className="text-tertiary">frecuentes</span>
							</h2>
						</div>
						<div className="ml-5">
							{faqs.map((item, index) => (
								<div
									key={index}
									className="mb-3 flex gap-4 border-b border-card py-3"
								>
									<div className="shrink-0 pt-1">
										<img src="/img/marketing/plus-bold.svg" alt="+" />
									</div>
									<div>
										<h3 className="mb-2 text-body-md font-bold">
											{item.title}
										</h3>
										<p>{item.description}</p>
									</div>
								</div>
							))}
						</div>
					</div>
				</div>
			</section>
		</main>
	)
}
